import React, { useState } from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "../dropdown-menu";
import { ChevronDown } from "lucide-react";

const GridColumnsSelect = ({
  gridColumnsOptions,
  onGridColumnsChange,
  defaultGridColumns,
}: any) => {
  const [gridColumns, setGridColumns] = useState(defaultGridColumns);
  const [gridColumnsMenuOpen, setGridColumnsMenuOpen] = useState(false);

  const handleActiveElement = (elem: any) => {
    setGridColumns(elem);
    setGridColumnsMenuOpen(false);
    onGridColumnsChange(elem.key);
  };

  return (
    <div className="flex /w-full h-full justify-start lg:justify-end">
      <DropdownMenu modal={false} open={gridColumnsMenuOpen}>
        <DropdownMenuTrigger
          onClick={() => setGridColumnsMenuOpen(!gridColumnsMenuOpen)}
          asChild
        >
          <div className="relative hover:bg-primary/90 bg-primary rounded-md cursor-pointer h-10 flex items-center justify-between px-2">
            <span className="flex h-full items-center gap-2 text-white">
              {gridColumns.label}
            </span>

            <ChevronDown className="h-4 w-4 ms-2 mt-1" />
          </div>
        </DropdownMenuTrigger>

        <DropdownMenuContent className="mt-1 w-[60px] min-w-0 flex flex-col gap-y-1 border-none bg-black drop-shadow-2xl py-2 text-white">
          {gridColumnsOptions.map((elem: any) => {
            return (
              <div
                key={elem?.key + elem?.dir}
                onClick={() => {
                  handleActiveElement(elem);
                }}
                className={`flex h-fit justify-center gap-10 rounded-none px-2 py-2 focus:border-none hover:cursor-pointer hover:bg-primary ${
                  gridColumns.key === elem?.key ? "bg-primary" : ""
                }`}
              >
                <div className="group flex items-center gap-2">
                  <p
                    className={`text-sm 
                   ${
                     gridColumns.key === elem?.key ? "text-white" : "text-white"
                   }`}
                  >
                    {elem?.label}
                  </p>
                </div>
              </div>
            );
          })}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default GridColumnsSelect;
